'use strict';

import Loader from '../../../_modules/loader/loader';
import { isFieldEmpty, isDecimal, displayErrors, isValidEmail } from './_helper';
import { toaster } from './_material';
import { invalid } from 'moment';

let $body = $('body'),
    $viewOrderReview = $('.view-order-review'),
    loader;

$(()=>{
    if ($viewOrderReview.length == 0) {
        return false;
    }

    let $btnEditAddress = $('.js-edit-order-review-address'),
        $formEditAddress = $('.update-order-review-address__dropdown'),
        $clientEmail = $('#ClientEmail'),
        $addressLine1 = $('#street_number'),
        $addressLine2 = $('#route'),
        $addressSuburb = $('#locality'),
        $suburbStatePostcode = $('#SuburbStatePostcode'),
        $addressPostCode = $('#postal_code'),
        $addressState = $('#administrative_area_level_1'),
        $deliveryNote = $('#DeliveryNotes'),
        $addressAdditionalNotes = $('#AdditionalAddressNotes'),
        getProductLines = () => $('.order-review-product-line'),
        $orderReviewProdsTotal = $('.order-review-products-total'),
        $btnSaveAddress = $('.js-save-order-review-address'),
        $btnReviewOrder = $('.js-review-order-products'),
        tenderSettingJson = JSON.parse($('#TenderSetting').val() || ''),
        $deliveryFeeDisplay = $('.order-review-delivery-fee'),
        $existingDeliveryFee = $('#ExistingDeliveryFee'),
        $orderTotal = $('.order-review-total'),
        $fullDeliveryAddress = $('#Delivery_Address_FullAddress'),
        freeDelivery = $('#FreeDelivery').val() == 'True',
        gst = $('#Gst').val(),
        $flatDeliveryFeeWithGst = $('#FlatDeliveryFeeWithGst'),
        $deliveryNoteDisplay = $('#DeliveryNoteDisplay'),
        $orderReviewAgreed = $('#OrderReviewAgreed'),
        $discardPaymentToken = $('#DiscardPaymentToken'),
        $source = $('#Source'),
        $token = $('#Token');
    
    // Put Loader in a variable
    loader = new Loader();
    
    // Edit Delivery fees
    $btnEditAddress.on('click', function (e) {
        e.preventDefault();
    
        $formEditAddress.slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false,
            complete: function () {
                $body.addClass('fixed');
            }
        });
    
    });
    
    $btnSaveAddress.on('click', function(e){
        e.preventDefault();
    
        let $errorContainer = $(this).parent().siblings('.server-errors__wrap'),
            invalidElements = [];
    
        if (isFieldEmpty($addressLine1)) {
            $addressLine1
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            invalidElements.push($addressLine1);
        }

        if (isFieldEmpty($addressPostCode)) {
            $addressPostCode
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            invalidElements.push($addressLine2);
        }

        if (isFieldEmpty($addressSuburb)) {
            $addressSuburb
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            invalidElements.push($addressSuburb);
        }

        if (isFieldEmpty($addressState)) {
            $addressState
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            invalidElements.push($addressState);
        }
    
        if(invalidElements.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            $(this).removeClass('error');
            $fullDeliveryAddress.val(`${$addressLine1.val()}, ${$addressSuburb.val()} ${$addressState.val()} ${$addressPostCode.val()}`);
            $deliveryNoteDisplay.val($deliveryNote.find('option:selected').text());
            $formEditAddress.slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.removeClass('fixed');
                }
            });
            return true;
        }
    });
    
    
    getProductLines().each(function(idx, element) {
        let $element = $(element),
            $btnPlus = $element.find('.btn-plus'),
            $btnMinus = $element.find('.btn-minus'),
            $btnRemove = $element.find('.js-remove-product'),
            $counterValue = $element.find('.counter-value'),
            maxIncrement = $counterValue.data("increment-max"),
            quantityIncrement = Number.parseInt($counterValue.data("quantity-increment")),
            cartonSize = $counterValue.data("carton-size"),
            originalValue = $counterValue.data('original-value');
        
        $btnPlus.on('click', function(e) {
            e.preventDefault();
            let $prodElement = $btnPlus.parents('.order-review-product-line'),
                increments = Number.parseInt($prodElement.data('increments')),
                currentValue = Number.parseInt($counterValue.val());

            if(currentValue > originalValue) {
                displayMaxReached($btnPlus);
                return false;
            };

            if(quantityIncrement > 1) {
                //if increments is in carton size
                if(currentValue < quantityIncrement) {
                    currentValue = quantityIncrement;
                } else if(currentValue % quantityIncrement != 0) {
                    currentValue = Math.round((currentValue / quantityIncrement)) * quantityIncrement;
                } else {
                    currentValue += quantityIncrement;
                }
            } else {
                currentValue++;
            }
            $counterValue.val(currentValue);
            updateProductsTotal();
        });
    
        $btnMinus.on('click', function(e) {
            e.preventDefault();
            let $prodElement = $btnPlus.parents('.order-review-product-line'),
                currentValue = $counterValue.val();
            
            if(currentValue <= quantityIncrement) {
                return false;
            }

            if(quantityIncrement > 1) {
                //if increments is in carton size
                if(currentValue % quantityIncrement != 0) {
                    currentValue = Math.round((currentValue / quantityIncrement)) * quantityIncrement;
                } else {
                    currentValue -= quantityIncrement;
                }
            } else {
                currentValue--;
            }
            if(currentValue < quantityIncrement) {
                currentValue = quantityIncrement;
            }
            $counterValue.val(currentValue);
            updateProductsTotal();
        });
    
        $btnRemove.on('click', function(e){
            e.preventDefault();
            $element.addClass('hidden');
            $element.addClass('removed-product');
            let $productLines = getProductLines();
            let $activeProducts = $productLines.filter(':not(.removed-product)');
            if($activeProducts.length == 1) {
                $activeProducts.find('.remove-button-holder').addClass('hidden');
            }
            updateProductsTotal();
        });
    });
    //change values on hover
    $('body').on('mouseover', '.flavours-listing li ', function() {

        let $this = $(this);

        if ($this.closest('.products-listing__wrapper').length) {
            $this.closest('.container').find('img.product-image').attr('src', $(this).data('image'));
        } else {
            let $selectedFlavour = $this.closest('.product-flavour').find('.product-flavour--selected'),
                prodId = $this.data("prod-id");

            $this.closest('.product-details__row').find('.product-description__image img').attr('src', $this.data('image'));
            $selectedFlavour.text($this.data('name'));
        }
    }).on('mouseout', '.flavours-listing li ', function() {

        let $this = $(this);

        if($this.is('.selected'))
            return false;

        let $productImage = $this.closest('.product-details__row').find('.product-description__image img'),
            $selectedFlavour = $this.closest('.product-flavour').find('.product-flavour--selected'),
            $selectedImage = $productImage.data('selected-image'),
            flavour = $selectedFlavour.attr('data-selected-flavour'),
            prodId = $this.siblings('.selected').attr('data-prod-id');

        if ($this.closest('.products-listing__wrapper').length) {
        } else {
            $productImage.attr('src', $selectedImage);
            $selectedFlavour.text(flavour);
        }
    });

    $('body').on('click', '.flavours-listing .flavour', function(e) {
        e.preventDefault();

        let $this = $(this),
            $flavourListing = $this.closest('.flavours-listing');
            
        let $productImage = $this.closest('.product-details__row').find('.product-description__image img'),
            $selectedFlavour = $this.closest('.product-flavour').find('.product-flavour--selected'),
            $selectedProduct = $this.closest('.product-flavour-quantity__enclosure'),
            inStock = $this.attr('data-in-stock');

        $flavourListing.find('.selected').removeClass('selected');
        $this.addClass('selected');

        $productImage.data('selected-image', $this.data('image'));
        $selectedFlavour.text($this.data('name'));
        $selectedFlavour.attr('data-selected-flavour', $this.data('name'));
    });

    let chkboxValidation = function($chkBox){
        if($chkBox.prop("checked")) {
            $chkBox.parent().removeClass('error');
            return true;
        } else {
            $chkBox.parent().addClass('error');
            return false;
        }
    }

    let displayMaxReached = function($btn) {
    }

    let updateProductsTotal = function(){
        let total = 0,
            deliveryFee = 0,
            noOfCartons = 0;
        
        getProductLines().each(function(idx, element) {
            let $element = $(element),
                $prodTotal = $element.find('.product-total-amount'),
                $counterValue = $element.find('.counter-value'),
                cartonSize = $counterValue.data('carton-size'),
                qty = Number.parseInt($counterValue.val()),
                price = Number.parseFloat($element.data('price'));
            
            if($element.hasClass('removed-product')) {
                return;
            }

            let prodTotal = price * qty;

            let prodCartons = Math.ceil(qty / cartonSize);
            noOfCartons = noOfCartons + prodCartons;

            $prodTotal.html(`$${prodTotal.toFixed(2)}`);

            prodTotal = Number.parseFloat(prodTotal.toFixed(2));
            total += prodTotal;
        });

        if(!freeDelivery) {
            if(tenderSettingJson.DeliveryCostType == 'Flat') {
                if(total < (tenderSettingJson.FreeDeliveryThreshold * .01)) {
                    deliveryFee = Number.parseFloat($flatDeliveryFeeWithGst.val());
                } else {
                    deliveryFee = 0;
                }
            } else {
                let existingDeliveryFee = Number.parseFloat($existingDeliveryFee.val());
                if($existingDeliveryFee.val() > 0) {
                    let oneCartonCost = 0,
                        twoCartonCost = 0,
                        threeCartonCost = 0,
                        $deliveryEl = null,
                        state = $addressState.val();

                    switch (state) {
                        case 'ACT':
                            $deliveryEl = $('#delivery-costs--ACT');
                            break;
                        case 'NSW':
                            $deliveryEl = $('#delivery-costs--NSW');
                            break;
                        case 'NT':
                            $deliveryEl = $('#delivery-costs--NT');
                            break;
                        case 'QLD':
                            $deliveryEl = $('#delivery-costs--QLD');
                            break;
                        case 'SA':
                            $deliveryEl = $('#delivery-costs--SA');
                            break;
                        case 'TAS':
                            $deliveryEl = $('#delivery-costs--TAS');
                            break;
                        case 'VIC':
                            $deliveryEl = $('#delivery-costs--VIC');
                            break;
                        case 'WA':
                            $deliveryEl = $('#delivery-costs--WA');
                            break;
                        default:
                            break;
                    }
                    
                    oneCartonCost = Number.parseFloat($deliveryEl.data('one-carton'));
                    twoCartonCost = Number.parseFloat($deliveryEl.data('two-carton'));
                    threeCartonCost = Number.parseFloat($deliveryEl.data('more-carton'));

                    deliveryFee = oneCartonCost;

                    if(noOfCartons > 1) {
                        deliveryFee = twoCartonCost;
                    }
                    if(noOfCartons > 2) {
                        deliveryFee = threeCartonCost;
                    }
    
                    if(deliveryFee > 0) {
                        deliveryFee = deliveryFee * .01;
                        let deliveryGst = deliveryFee * gst;
                        deliveryFee = (deliveryFee + deliveryGst);
                    }
                }
            }
        }

        let totalWithDelivery = total + deliveryFee;
        total = total.toFixed('2');
        $orderReviewProdsTotal.html(`$${total}`);

        //update delivery cost
        $deliveryFeeDisplay.html(`$${deliveryFee.toFixed('2')}`);

        //add it to the order total
        $orderTotal.html(`$${totalWithDelivery.toFixed('2')}`);
    }
    
    $btnReviewOrder.on('click', function (e) {
        let $errorContainer = $('.js-update-order-products').parent().siblings('.server-errors__wrap'),
            $editProductsModal = $('.form-modal--edit-order-products'),
            dataParams = {},
            dataOrderModel = [],
            isChk1 = chkboxValidation($orderReviewAgreed);

        if (!isFieldEmpty($clientEmail) && !isValidEmail($clientEmail.val())) {
            toaster('Email address provided is not valid.', 'error');
            $(this).addClass('error');
            $clientEmail.trigger('focus');
            e.preventDefault();
            return false;
        } else {
            $(this).removeClass('error');
        }

        if (!isChk1) {
            toaster('You must acknowledge the order to continue to payment.', 'error');
            $(this).addClass('error');
            e.preventDefault();
            return false;
        } else {
            $(this).removeClass('error');
        }
        

        getProductLines().each(function(idx, element) {
            let $element = $(element),
                $counterValue = $element.find('.counter-value'),
                $price = Number.parseFloat($element.data('price')),
                prodTotal = $price * $counterValue.val(),
                orderProductId = $element.data('id'),
                productTypeId = $element.data('prod-type-id'),
                prodId = $element.find('li.selected').data('prod-id');
            
            if(!$element.hasClass('removed-product')) {
                dataOrderModel.push({
                    ProductTypeId: productTypeId,
                    ProductId: prodId,
                    OrderProductId: orderProductId,
                    Quantity: $counterValue.val()
                });
            }
        });
        loader.fadeIn();
    
        dataParams = {
            'OrderId' : $('#OrderId').val(),
            'Products': dataOrderModel,
            'EmailAddress': $clientEmail.val(),
            'Address': {
                Address1: $addressLine1.val(),
                Address2: $addressLine2.val(),
                Suburb: $addressSuburb.val(),
                Postcode: $addressPostCode.val(),
                State: $addressState.val(),
                AdditionalNotes: $addressAdditionalNotes.val(),
            },
            'Token': $token.val(),
            'DiscardPaymentToken': $discardPaymentToken.val(),
            'Source': $source.val(),
            'DeliveryNote': $deliveryNote.find('option:selected').text()
        };
    
        $.ajax({
            url: '/api/orders/saveorderreview',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: { __RequestVerificationToken: $viewOrderReview.find('input[name=__RequestVerificationToken]').val() },
            type: 'POST', 
            data: JSON.stringify(dataParams),
            success: function (data) {
                loader.fadeOut();
                window.location.href = data.href;
                toaster('Order has been saved successfully. Please wait while we redirect you to the payment page.');
    
                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
    
            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer ); 
            }
        });
    
    });


})




